module.exports = __webpack_public_path__ + "static/media/1015889.84f9a595.png";